export default "__VITE_ASSET__CoRNTurr__"